(() => {
  const init = () => {
    const root = document.querySelector('.caveau-product-layout');
    const bar = document.querySelector('[data-cv-sticky-bar]');
    if (!root || !bar || root.dataset.cvReady) return;
    root.dataset.cvReady = 'true';
    const notes = root.querySelector('[data-cv-product-notes]');
    if (notes) fetch(notes.dataset.index).then(r => r.ok ? r.json() : Promise.reject()).then(data => {
      const entry = data.products.find(p => p.handle === notes.dataset.handle);
      if (entry?.notes.length) {
        notes.querySelector('[data-cv-note-list]').textContent = entry.notes.join(' · ');
        notes.hidden = false;
      }
    }).catch(() => {});
    const json = root.querySelector('script[id^="ProductCardJson-"]');
    let product;
    try { product = JSON.parse(json.textContent); } catch { return; }
    const button = bar.querySelector('button');
    const price = bar.querySelector('[data-cv-sticky-price]');
    const size = bar.querySelector('[data-cv-sticky-size]');
    const setText = (el, value) => { if (el && el.textContent !== value) el.textContent = value; };
    let observedButton;
    let onScreen = false;
    const visibility = new IntersectionObserver(entries => {
      onScreen = entries[0].isIntersecting;
      bar.hidden = onScreen;
    }, { threshold: 0.2 });
    const sync = () => {
      const nativeButton = root.querySelector('.main-product_atc-btn');
      const id = root.querySelector('#main-product-atc-form input[name="id"]')?.value;
      const variant = product.variants.find(v => String(v.id) === String(id));
      if (!nativeButton || !variant) { bar.hidden = true; return; }
      if (observedButton !== nativeButton) {
        visibility.disconnect(); visibility.observe(nativeButton); observedButton = nativeButton;
      }
      setText(button, nativeButton.textContent.trim());
      button.disabled = nativeButton.disabled;
      const renderedPrice = root.querySelector('[data-render-price="main-product"] .main-price');
      setText(price, renderedPrice?.textContent.trim() || new Intl.NumberFormat(document.documentElement.lang, {style:'currency',currency:bar.dataset.currency || 'EUR'}).format(variant.price / 100));
      setText(size, variant.title === 'Default Title' ? '' : variant.title);
      // Le rate mostrate sotto il prezzo seguono il formato scelto (di partenza: il flacone).
      const installments = (variant.price / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      root.querySelectorAll('scalapay-widget[type="product"]').forEach((widget) => {
        if (widget.getAttribute('amount') !== installments) widget.setAttribute('amount', installments);
      });
      const free = bar.dataset.country === 'IT' && bar.dataset.currency === 'EUR' && variant.price > 5900;
      setText(root.querySelector('[data-cv-shipping]'), free ? bar.dataset.free : bar.dataset.threshold);
      bar.hidden = onScreen;
    };
    button.addEventListener('click', () => {
      const nativeButton = root.querySelector('.main-product_atc-btn');
      if (nativeButton && !nativeButton.disabled) nativeButton.click();
    });
    new MutationObserver(sync).observe(root, {subtree:true, childList:true, attributes:true, attributeFilter:['value','disabled']});
    root.addEventListener('change', sync);
    document.documentElement.classList.add('cv-has-sticky');
    sync();
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
